import { IIdsRequest } from "../../model/request/IIdsRequest";
import { IHinhThucThi } from "../../model/respone/tct/IHinhThucThi";
import { apiClient } from "../apiClient";

export const HINH_THUC_THI = "hinh-thuc-thi";
export const hinhThucThiApi = {
  SelectAll: () => apiClient.get(`${HINH_THUC_THI}`),
  Insert: (payload: IHinhThucThi) => apiClient.post(`${HINH_THUC_THI}`, payload),
  Update: (payload: IHinhThucThi) => apiClient.put(`${HINH_THUC_THI}`, payload),
  Delete: (id: number) => apiClient.delete(`${HINH_THUC_THI}/${id}`),
  Deletes: (ids: IIdsRequest) => apiClient.post(`${HINH_THUC_THI}/deletes`,ids),
};
